/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CarePrincipalStatistics,
    CarePrincipalStatisticsFromJSON,
    CarePrincipalStatisticsToJSON,
    PageLogEventEntity,
    PageLogEventEntityFromJSON,
    PageLogEventEntityToJSON,
    Pageable,
    PageableFromJSON,
    PageableToJSON,
} from '../models';

export interface GetAllLogsRequest {
    pageable: Pageable;
}

export interface GetCarePrincipalStatisticsRequest {
    id: string;
    dateFrom: Date;
    dateTo: Date;
}

export interface GetCarePrincipalStatisticsAsCsvRequest {
    carePrincipalIds: Array<string>;
    dateFrom: Date;
    dateTo: Date;
    column1177: boolean;
}

export interface GetLogsAsPDFRequest {
    id: string;
    logTarget: string;
    actions: string;
    dateFrom: Date;
    dateTo: Date;
}

export interface GetLogsAsXMLRequest {
    id: string;
    logTarget: string;
    actions: string;
    dateFrom: Date;
    dateTo: Date;
}

export interface GetLogsWithParametersRequest {
    id: string;
    logTarget: string;
    actions: string;
    dateFrom: Date;
    dateTo: Date;
    size: number;
    page: number;
    sort: string;
}

/**
 * 
 */
export class LogApi extends runtime.BaseAPI {

    /**
     */
    async getAllActionsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/log/actions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getAllActions(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getAllActionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllLogsRaw(requestParameters: GetAllLogsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PageLogEventEntity>> {
        if (requestParameters.pageable === null || requestParameters.pageable === undefined) {
            throw new runtime.RequiredError('pageable','Required parameter requestParameters.pageable was null or undefined when calling getAllLogs.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageable !== undefined) {
            queryParameters['pageable'] = requestParameters.pageable;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/logs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageLogEventEntityFromJSON(jsonValue));
    }

    /**
     */
    async getAllLogs(pageable: Pageable, initOverrides?: RequestInit): Promise<PageLogEventEntity> {
        const response = await this.getAllLogsRaw({ pageable: pageable }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalStatisticsRaw(requestParameters: GetCarePrincipalStatisticsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CarePrincipalStatistics>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCarePrincipalStatistics.');
        }

        if (requestParameters.dateFrom === null || requestParameters.dateFrom === undefined) {
            throw new runtime.RequiredError('dateFrom','Required parameter requestParameters.dateFrom was null or undefined when calling getCarePrincipalStatistics.');
        }

        if (requestParameters.dateTo === null || requestParameters.dateTo === undefined) {
            throw new runtime.RequiredError('dateTo','Required parameter requestParameters.dateTo was null or undefined when calling getCarePrincipalStatistics.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['dateFrom'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['dateTo'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/log/getcareprincipalstatistics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CarePrincipalStatisticsFromJSON));
    }

    /**
     */
    async getCarePrincipalStatistics(id: string, dateFrom: Date, dateTo: Date, initOverrides?: RequestInit): Promise<Array<CarePrincipalStatistics>> {
        const response = await this.getCarePrincipalStatisticsRaw({ id: id, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalStatisticsAsCsvRaw(requestParameters: GetCarePrincipalStatisticsAsCsvRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.carePrincipalIds === null || requestParameters.carePrincipalIds === undefined) {
            throw new runtime.RequiredError('carePrincipalIds','Required parameter requestParameters.carePrincipalIds was null or undefined when calling getCarePrincipalStatisticsAsCsv.');
        }

        if (requestParameters.dateFrom === null || requestParameters.dateFrom === undefined) {
            throw new runtime.RequiredError('dateFrom','Required parameter requestParameters.dateFrom was null or undefined when calling getCarePrincipalStatisticsAsCsv.');
        }

        if (requestParameters.dateTo === null || requestParameters.dateTo === undefined) {
            throw new runtime.RequiredError('dateTo','Required parameter requestParameters.dateTo was null or undefined when calling getCarePrincipalStatisticsAsCsv.');
        }

        if (requestParameters.column1177 === null || requestParameters.column1177 === undefined) {
            throw new runtime.RequiredError('column1177','Required parameter requestParameters.column1177 was null or undefined when calling getCarePrincipalStatisticsAsCsv.');
        }

        const queryParameters: any = {};

        if (requestParameters.carePrincipalIds) {
            queryParameters['carePrincipalIds'] = requestParameters.carePrincipalIds;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['dateFrom'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['dateTo'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.column1177 !== undefined) {
            queryParameters['column1177'] = requestParameters.column1177;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/log/getcsvfile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getCarePrincipalStatisticsAsCsv(carePrincipalIds: Array<string>, dateFrom: Date, dateTo: Date, column1177: boolean, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.getCarePrincipalStatisticsAsCsvRaw({ carePrincipalIds: carePrincipalIds, dateFrom: dateFrom, dateTo: dateTo, column1177: column1177 }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLogsAsPDFRaw(requestParameters: GetLogsAsPDFRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getLogsAsPDF.');
        }

        if (requestParameters.logTarget === null || requestParameters.logTarget === undefined) {
            throw new runtime.RequiredError('logTarget','Required parameter requestParameters.logTarget was null or undefined when calling getLogsAsPDF.');
        }

        if (requestParameters.actions === null || requestParameters.actions === undefined) {
            throw new runtime.RequiredError('actions','Required parameter requestParameters.actions was null or undefined when calling getLogsAsPDF.');
        }

        if (requestParameters.dateFrom === null || requestParameters.dateFrom === undefined) {
            throw new runtime.RequiredError('dateFrom','Required parameter requestParameters.dateFrom was null or undefined when calling getLogsAsPDF.');
        }

        if (requestParameters.dateTo === null || requestParameters.dateTo === undefined) {
            throw new runtime.RequiredError('dateTo','Required parameter requestParameters.dateTo was null or undefined when calling getLogsAsPDF.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.logTarget !== undefined) {
            queryParameters['logTarget'] = requestParameters.logTarget;
        }

        if (requestParameters.actions !== undefined) {
            queryParameters['actions'] = requestParameters.actions;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['dateFrom'] = (requestParameters.dateFrom as any).toISOString();
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['dateTo'] = (requestParameters.dateTo as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/log/pdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getLogsAsPDF(id: string, logTarget: string, actions: string, dateFrom: Date, dateTo: Date, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.getLogsAsPDFRaw({ id: id, logTarget: logTarget, actions: actions, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLogsAsXMLRaw(requestParameters: GetLogsAsXMLRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getLogsAsXML.');
        }

        if (requestParameters.logTarget === null || requestParameters.logTarget === undefined) {
            throw new runtime.RequiredError('logTarget','Required parameter requestParameters.logTarget was null or undefined when calling getLogsAsXML.');
        }

        if (requestParameters.actions === null || requestParameters.actions === undefined) {
            throw new runtime.RequiredError('actions','Required parameter requestParameters.actions was null or undefined when calling getLogsAsXML.');
        }

        if (requestParameters.dateFrom === null || requestParameters.dateFrom === undefined) {
            throw new runtime.RequiredError('dateFrom','Required parameter requestParameters.dateFrom was null or undefined when calling getLogsAsXML.');
        }

        if (requestParameters.dateTo === null || requestParameters.dateTo === undefined) {
            throw new runtime.RequiredError('dateTo','Required parameter requestParameters.dateTo was null or undefined when calling getLogsAsXML.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.logTarget !== undefined) {
            queryParameters['logTarget'] = requestParameters.logTarget;
        }

        if (requestParameters.actions !== undefined) {
            queryParameters['actions'] = requestParameters.actions;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['dateFrom'] = (requestParameters.dateFrom as any).toISOString();
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['dateTo'] = (requestParameters.dateTo as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/log/xml`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getLogsAsXML(id: string, logTarget: string, actions: string, dateFrom: Date, dateTo: Date, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.getLogsAsXMLRaw({ id: id, logTarget: logTarget, actions: actions, dateFrom: dateFrom, dateTo: dateTo }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLogsWithParametersRaw(requestParameters: GetLogsWithParametersRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PageLogEventEntity>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.logTarget === null || requestParameters.logTarget === undefined) {
            throw new runtime.RequiredError('logTarget','Required parameter requestParameters.logTarget was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.actions === null || requestParameters.actions === undefined) {
            throw new runtime.RequiredError('actions','Required parameter requestParameters.actions was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.dateFrom === null || requestParameters.dateFrom === undefined) {
            throw new runtime.RequiredError('dateFrom','Required parameter requestParameters.dateFrom was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.dateTo === null || requestParameters.dateTo === undefined) {
            throw new runtime.RequiredError('dateTo','Required parameter requestParameters.dateTo was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getLogsWithParameters.');
        }

        if (requestParameters.sort === null || requestParameters.sort === undefined) {
            throw new runtime.RequiredError('sort','Required parameter requestParameters.sort was null or undefined when calling getLogsWithParameters.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.logTarget !== undefined) {
            queryParameters['logTarget'] = requestParameters.logTarget;
        }

        if (requestParameters.actions !== undefined) {
            queryParameters['actions'] = requestParameters.actions;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['dateFrom'] = (requestParameters.dateFrom as any).toISOString();
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['dateTo'] = (requestParameters.dateTo as any).toISOString();
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/log`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageLogEventEntityFromJSON(jsonValue));
    }

    /**
     */
    async getLogsWithParameters(id: string, logTarget: string, actions: string, dateFrom: Date, dateTo: Date, size: number, page: number, sort: string, initOverrides?: RequestInit): Promise<PageLogEventEntity> {
        const response = await this.getLogsWithParametersRaw({ id: id, logTarget: logTarget, actions: actions, dateFrom: dateFrom, dateTo: dateTo, size: size, page: page, sort: sort }, initOverrides);
        return await response.value();
    }

}
